<template>
    <transition name="bounce">
        <div
            v-if="hasErrors"
            class="
                w-full
                sm:max-w-md
                my-10
                px-6
                py-4
                text-secondary
                bg-white
                shadow-md
                overflow-hidden
                sm:rounded-lg
            "
        >
            <div class="font-medium">Whoops! Something went wrong.</div>

            <ul class="mt-3 list-disc list-inside text-sm">
                <li v-for="(error, key) in errors" :key="key">{{ error }}</li>
            </ul>
        </div>
    </transition>
</template>

<style scoped>
.bounce-enter-active {
    animation: bounce-in 0.5s;
}

.bounce-leave-active {
    animation: bounce-in 0.5s reverse;
}

@keyframes bounce-in {
    0% {
        transform: scale(0);
    }
    50% {
        transform: scale(1.2);
    }
    100% {
        transform: scale(1);
    }
}
</style>

<script>
export default {
    computed: {
        errors() {
            return this.$page.props.errors;
        },

        hasErrors() {
            return Object.keys(this.errors).length > 0;
        },
    },
};
</script>
